module.exports = "/_next/static/images/1ae54f6dbee5e55d8796e324445527e4-image-right-xs.jpg.webp";